import { useState, useEffect } from 'react'
import { getNewSexsAPI } from '../services/newSex'
import { useTranslation } from 'react-i18next'

function UseSexsLeave() {
  const { t } = useTranslation()
  const [data, setData] = useState([])

  useEffect(() => {
    const getData = async () => {
      const result = await getNewSexsAPI()
      if (!result) return

      const newData = result.result.map((d) => {
        return {
          value: d.value,
          label: d.sex
        }
      })

      setData([{ value: 'ALL', label: t('hrms_setting_leave_form_sex_all') }, ...newData])
    }

    getData()
  }, [])

  return data
}

export default UseSexsLeave
